<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <BranchPrivilegeForm
      v-if="!isLoading"
      :userBranchPrivilegeDate="userBranchPrivilegeDate"
      :submitName="$t('edit')"
      v-on:updateUserBranchPrivilege="updateUserBranchPrivilege"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import BranchPrivilegeForm from "@/components/privileges/branchPrivileges/BranchPrivilegeForm.vue";
import UsersBranchPrivilege from "@/models/privileges/branchPrivileges/UsersBranchPrivilege";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "BranchPrivileges",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    BranchPrivilegeForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      userBranchPrivilegeDate: new UsersBranchPrivilege(),
    };
  },
  methods: {
    async updateUserBranchPrivilege() {
      this.isLoading = true;
      try {
        let response =
          await this.userBranchPrivilegeDate.updateUserBranchPrivilege(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.userBranchPrivilegeDate.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
